import { BONES } from './Gestures.js';

/**
 * Dibuja el esqueleto sobre un canvas. Los puntos llegan en espejo y en alturas de imagen
 * (x de 0 a aspect, y de 0 a 1), así que solo hay que escalarlos por el alto del canvas.
 * Sirve para la pantalla de calibración (sobre el vídeo) y para la miniatura durante la partida.
 */
export class SkeletonView {
  constructor(canvas) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
  }

  /** Ajusta la resolución del canvas a su tamaño en pantalla. */
  #fit() {
    const c = this.canvas;
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    const w = Math.round(c.clientWidth * dpr);
    const h = Math.round(c.clientHeight * dpr);
    if (c.width !== w || c.height !== h) {
      c.width = w;
      c.height = h;
    }
  }

  /**
   * points: Float32Array(51) o null. opts: { minScore, color, highlight: Set de índices, video }
   * El canvas debe tener la proporción de la imagen de la cámara. Si se pasa `video`, se dibuja
   * debajo en espejo: así imagen y esqueleto coinciden siempre (mismo canvas, misma escala).
   */
  draw(points, { minScore = 0.3, color = '#7dff9a', highlight = null, lineWidth = 4, video = null } = {}) {
    this.#fit();
    const { ctx, canvas } = this;
    if (video?.videoWidth) {
      ctx.save();
      ctx.setTransform(-1, 0, 0, 1, canvas.width, 0);
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      ctx.restore();
    } else ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!points) return;
    const k = canvas.height;
    const ok = (i) => points[i * 3 + 2] >= minScore;
    const lw = lineWidth * (canvas.height / 360);
    ctx.lineCap = 'round';
    ctx.lineWidth = lw;
    ctx.strokeStyle = color;
    ctx.beginPath();
    for (const [a, b] of BONES) {
      if (!ok(a) || !ok(b)) continue;
      ctx.moveTo(points[a * 3] * k, points[a * 3 + 1] * k);
      ctx.lineTo(points[b * 3] * k, points[b * 3 + 1] * k);
    }
    ctx.stroke();
    for (let i = 0; i < 17; i++) {
      if (!ok(i)) continue;
      ctx.fillStyle = highlight?.has(i) ? '#ffd23a' : '#ffffff';
      ctx.beginPath();
      ctx.arc(points[i * 3] * k, points[i * 3 + 1] * k, lw * (highlight?.has(i) ? 1.5 : 0.9), 0, Math.PI * 2);
      ctx.fill();
    }
  }
}
